import React, { memo } from 'react'
import { Select } from 'antd'
import ciList from '../../store/ci-list'

const ciOptions = ciList.map((item) => ({
  label: `${item.name} (${item.value})`,
  value: item.value,
}))

const SISelect = ({ value, onChange }) => (
  <Select
    filterOption={(inputValue, option) => option.label?.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0}
    value={value}
    showSearch
    options={ciOptions}
    onChange={onChange}
    dropdownMatchSelectWidth={false}
  />
)

export default memo(SISelect)
